import { render, staticRenderFns } from "./MultiInput.vue?vue&type=template&id=2f388b67&"
import script from "./MultiInput.vue?vue&type=script&lang=ts&"
export * from "./MultiInput.vue?vue&type=script&lang=ts&"
import style0 from "./MultiInput.vue?vue&type=style&index=0&id=2f388b67&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports